module.exports = __webpack_public_path__ + "img/CM-BS-24-Volvo-Modern.2b28eaed.jpg";